module.exports = __webpack_public_path__ + "img/edit-blue-16dp.bbc5978c.svg";